import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  leadList: { data: [], total: 0 },
};

const leadsSlice = createSlice({
  name: "leadSlice",
  initialState,
  reducers: {
    leadList(state, action) {
      const payload = action.payload;
      state.leadList = Array.isArray(payload)
        ? { data: payload, total: payload.length }
        : payload || { data: [], total: 0 };
    },
  },
});

export const { leadList } = leadsSlice.actions;
export default leadsSlice.reducer;
